import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/products',
          component: resolve => require(['@/view/Products/index'], resolve),
          meta: {
            title: '产品'
          },
          children: [
            {
              path: '/products',
              redirect: '/products/djiAircraft'
            },
            {
              path: '/products/djiAircraft',
              name: 'djiAircraft',
              component: resolve => require(['@/view/Products/DjiAircraft'], resolve),
              meta: {
                title: '行业应用无人机'
              }
            },
            {
              path: '/products/payloads',
              name: 'payloads',
              component: resolve => require(['@/view/Products/Payloads'], resolve),
              meta: {
                title: '无人机负载'
              }
            },
            {
              path: '/products/software',
              name: 'software',
              component: resolve => require(['@/view/Products/Software'], resolve),
              meta: {
                title: '软件与服务'
              }
            },
            {
              path: '/products/develop',
              name: 'develop',
              component: resolve => require(['@/view/Products/Develop'], resolve),
              meta: {
                title: '软件定制开发'
              }
            },
            // {
            //   path: '/djiDetail',
            //   name: 'djidetail',
            //   component: resolve => require(['@/view/Products/DjiDetail'], resolve),
            //   meta: {
            //     title: '设备详情'
            //   }
            // },
            // {
            //   path: '/products/consult',
            //   name: 'consult',
            //   component: resolve => require(['@/view/Products/Consult'], resolve),
            //   meta: {
            //     title: '飞行咨询服务'
            //   }
            // }
          ]
        },
        {
          path: '/solutions',
          name: 'solutions',
          component: resolve => require(['@/view/Solutions/index'], resolve),
          meta: {
            title: '解决方案'
          }
        },
        {
          path: '/news',
          component: resolve => require(['@/view/News/index'], resolve),
          meta: {
            title: '公司动态'
          }
        },
        {
          path: '/info',
          component: resolve => require(['@/view/Info/index'], resolve),
          meta: {
            title: '公司介绍'
          }
        },
        {
          path: '/joinus',
          component: resolve => require(['@/view/JoinUs/index'], resolve),
          meta: {
            title: '加入我们'
          }
        },
        {
          path: '/contactus',
          component: resolve => require(['@/view/ContactUs/index'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/detail',
          name: 'detail',
          component: resolve => require(['@/view/Detail'], resolve),
          meta: {
            title: '详情'
          }
        },
      ]
    }
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js